import type { SVGProps } from "react";
const SvgDescription = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
        <path
            fill="currentColor"
            d="M17 2.665a.999.999 0 1 1 0 2H1a1 1 0 0 1 0-2zm0 5.333c.554 0 1 .446 1 1 0 .555-.446 1-1 1H1a.999.999 0 1 1 0-2zM0 14.332a1 1 0 0 1 1-1h13.61c.555 0 1 .446 1 1s-.445 1-1 1H1a1 1 0 0 1-1-1"
        />
    </svg>
);
export default SvgDescription;
